/**
 * Issue #662 — guard for the manager-reachable per-inbox settings route
 * (/inbox/:inboxId/settings). Extracted verbatim from App.js (QA F-002) so the
 * real gate can be unit-tested against the REAL PermissionsContext store —
 * including the cold-load park fix (token present, /auth/me still hydrating →
 * unknown → wait).
 *
 * Composes ProtectedRoute (auth + its pending/reconnecting branches) with ONE
 * scoped permission check from the #663 permission store. The order is
 * load-bearing: the check NEVER decides while the store is unknown. A manager
 * landing directly on /inbox/:id/settings next day (cold load) must see the
 * page, never a redirect — deciding on the store's fail-closed default would
 * bounce legitimately entitled users (the same failure mode WorkspaceContext
 * documents for the sidebar). Unknown waits; a resolved "no" redirects to
 * /inbox.
 */
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { usePermissions } from '../../context/PermissionsContext';

export function InboxManagerGate({ children }) {
    const { inboxId } = useParams();
    const { can, permissionsUnknown } = usePermissions();

    if (permissionsUnknown) {
        return (
            <div className="min-h-screen bg-stone-50 flex items-center justify-center">
                <div className="text-center">
                    <div className="w-10 h-10 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                    <p className="text-stone-500 text-sm">Loading CRM...</p>
                </div>
            </div>
        );
    }
    if (!can('inbox:manage', { type: 'inbox', id: inboxId })) {
        return <Navigate to="/inbox" replace />;
    }
    return children;
}
